enum IssueStatus {
  UNDEFINED = 0,
  NEW = 1,
  RESOLVED = 2,
}

export default IssueStatus
